<template>
  <div class="container sv039">
    <BreadcrumbGroup :items="breadcrumbItems" />

    <HeadingOne class="_mb-sm-40 _mb-md-60">サイトマップ</HeadingOne>

    <section>
      <div class="txt01 _mb-sm-40 _mb-md-60">
        <BtnText router-name="sv001" class="-next"
          >au PAY スマートローン トップ</BtnText
        >
      </div>
      <hr />
      <div class="txt01 _mt-sm-40 _mt-md-60 _mb-sm-40 _mb-md-60">
        <BtnText router-name="sv002" class="-next"
          >au PAY スマートローンの特徴</BtnText
        >
      </div>
    </section>

    <section>
      <div class="row">
        <div class="col-12 col-md-4 _mb-sm-40 _mb-md-60">
          <div class="txt01 _mb-sm-20 _mb-md-25">
            <BtnText router-name="sv003" class="-next"
              >知っておきたい！ローンについて</BtnText
            >
          </div>
          <router-link :to="{ name: 'sv043' }" class="-link"
            >いまさら聞けない！ローンの基礎知識</router-link
          >
          <router-link :to="{ name: 'sv042' }" class="-link"
            >教えて！みんなのローン活用術</router-link
          >
          <router-link :to="{ name: 'sv044' }" class="-link"
            >auサービスでもっとおトクに！</router-link
          >
        </div>
        <div class="col-12 col-md-4 _mb-sm-40 _mb-md-60">
          <div class="txt01 _mb-sm-20 _mb-md-25">
            <BtnText router-name="sv045" class="-next"
              >新規お申し込みについて</BtnText
            >
          </div>
          <router-link :to="{ name: 'sv045' }" class="-link"
            >お申し込み条件・お手続きの流れ</router-link
          >
          <router-link :to="{ name: 'sv018' }" class="-link"
            >ご利用可能な金融機関</router-link
          >
          <router-link :to="{ name: 'sv019' }" class="-link"
            >お申し込みに必要な書類</router-link
          >
          <router-link :to="{ name: 'sv057' }" class="-link"
            >収入証明書について</router-link
          >
          <router-link :to="{ name: 'sv021' }" class="-link"
            >いくら借りられるの？チェック</router-link
          >
          <router-link :to="{ name: 'sv059' }" class="-link"
            >会員さま専用サイト・専用アプリについて</router-link
          >
        </div>
        <div class="col-12 col-md-4 _mb-sm-40 _mb-md-60">
          <div class="txt01 _mb-sm-20 _mb-md-25">
            <BtnText router-name="sv046" class="-next"
              >お借り入れについて</BtnText
            >
          </div>
          <router-link :to="{ name: 'sv046' }" class="-link"
            >お借り入れ方法</router-link
          >
          <router-link :to="{ name: 'sv024' }" class="-link"
            >au PAY 残高にチャージ</router-link
          >
          <router-link :to="{ name: 'sv023' }" class="-link"
            >ご登録口座へのお振込み</router-link
          >
          <router-link :to="{ name: 'sv025' }" class="-link"
            >セブン銀行スマホATM</router-link
          >
          <router-link :to="{ name: 'sv022' }" class="-link"
            >お利息のご案内</router-link
          >
        </div>
        <div class="col-12 col-md-4 _mb-sm-40 _mb-md-60">
          <div class="txt01 _mb-sm-20 _mb-md-25">
            <BtnText router-name="sv047" class="-next">ご返済について</BtnText>
          </div>
          <router-link :to="{ name: 'sv047' }" class="-link"
            >ご返済方法</router-link
          >
          <router-link :to="{ name: 'sv026' }" class="-link"
            >ご登録口座からのお引落し</router-link
          >
          <router-link :to="{ name: 'sv029' }" class="-link"
            >セブン銀行スマホATM</router-link
          >
          <router-link :to="{ name: 'sv027' }" class="-link"
            >指定口座へのお振込み</router-link
          >
          <router-link :to="{ name: 'sv052' }" class="-link"
            >ご返済シミュレーション</router-link
          >
        </div>
      </div>
    </section>

    <hr />

    <section>
      <div class="link-box _mt-sm-40 _mt-md-60 _mb-md-120 _mb-sm-60">
        <a
          href="https://qa.kddi-fs.com/?site_domain=loan"
          target="_blank"
          class="-link _mr-30"
          >よくあるご質問</a
        >
        <router-link :to="{ name: 'cp001' }" class="-link _mr-30"
          >キャンペーン一覧</router-link
        >
        <router-link :to="{ name: 'nw001' }" class="-link _mr-30"
          >トピックス一覧</router-link
        >
        <router-link :to="{ name: 'nw003' }" class="-link _mr-30"
          >重要なお知らせ一覧</router-link
        >
        <router-link :to="{ name: 'nw005' }" class="-link _mr-30"
          >ニュースリリース一覧</router-link
        >
      </div>
    </section>
  </div>
  <!-- container -->
</template>

<script>
import { setMeta } from "@/utils/Meta";
import BreadcrumbGroup from "@/components/breadcrumb/BreadcrumbGroup";
import HeadingOne from "@/components/heading/HeadingOne";
import BtnText from "@/components/button/BtnText";

export default {
  name: "Sv039",
  components: {
    BreadcrumbGroup,
    HeadingOne,
    BtnText,
  },
  setup() {
    setMeta({
      title: "サイトマップ",
      description:
        "サイトマップになります。au PAY スマートローンはau IDをお持ちのお客様のための便利なカードレスローンサービスです。お申込みは、スマートフォン・パソコンでかんたんWEB完結！24時間お申込み可能。最短30分で審査結果をご連絡します。",
      keywords:
        "au PAY スマートローン,au,カードレスローン,スマートフォン,au PAY 残高,セブン銀行スマホATM,借入,返済,手続き,サイトマップ",
    });
  },
  data() {
    return {
      breadcrumbItems: [
        {
          text: "トップ",
          routerName: "root",
        },
        {
          text: "サイトマップ",
          active: true,
        },
      ],
    };
  },
};
</script>

<style lang="scss" scoped>
@import "@/assets/stylesheets/styles";

.sv039 {
  hr {
    border-top: 1px dotted $secondary;
  }
  .txt01 {
    font-size: 18px;
    line-height: 28px;
    font-weight: bold;
  }
  a {
    &.-link {
      display: block;
      margin-bottom: 10px;
      &:hover {
        color: $orange;
        text-decoration: underline;
      }
    }
  }
  .link-box {
    a {
      @include mq-up(md) {
        display: inline-block;
      }
    }
  }
}
</style>
